import { useEffect } from 'react';
import HistoryTime from 'components/HistoryTime';
import _ from 'lodash';
import { fetchLanguages } from 'slices/language.slice';
import { useAppDispatch } from 'slices/store';
import { EFieldType, EPersonalDataCheck } from '@timeedit/types/lib/enums';
import type { TField } from '@timeedit/types/lib/types';
// Types
// Components
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';

type tProps = {
  value: TField;
  onChangeValue: (type: string, value: any) => void;
};
export const GeneralInfo = ({ value, onChangeValue }: tProps) => {
  const fieldTypeOption = Object.keys(EFieldType);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchLanguages());
  }, [dispatch]);

  return (
    <TEDrawerSection label="General Info">
      <div className="wrapper-section">
        <div className="section-item">
          <TEInput.Select
            value={value.fieldType}
            onChange={(e) => onChangeValue('fieldType', e)}
            label="Type"
            tooltip="Type"
            disabled={value.id !== 0}
            data-testid="general-type"
            options={fieldTypeOption
              .map((i: any) => ({
                label: _.capitalize(i),
                value: i,
              }))
              .sort((a, b) => a.label.localeCompare(b.label))}
          />
          <TEInput.Input
            value={value.name}
            onChange={(e) => onChangeValue('name', e)}
            label="Name"
            tooltip="Name"
            placeholder="New field"
            data-testid="general-name"
          />
          <TEInput.TextArea
            value={value.description}
            onChange={(e) => onChangeValue('description', e)}
            label="Description"
            tooltip="Description"
            data-testid="general-description"
          />
          <TEInput.Input
            value={value.extId}
            onChange={(e) => onChangeValue('extId', e)}
            label="Exd.Id"
            tooltip="Exd.Id"
            data-testid="general-exd-id"
          />
        </div>
        <div className="section-item">
          <TEInput.PureText value={`${value?.id}`} label="Id" tooltip="Id" />
          <TEInput.Select
            value={value.personalData}
            onChange={(val) => onChangeValue('personalData', val)}
            label="Personal Data"
            tooltip="Personal Data"
            options={Object.keys(EPersonalDataCheck).map((i) => ({
              label: _.capitalize(i),
              value: i,
            }))}
            data-testid="general-personal-data"
          />
          <div className="te-drawer-input">
            <HistoryTime history={value?.history} />
          </div>
        </div>
      </div>
    </TEDrawerSection>
  );
};
